import React from 'react';
import { Stack, Text, Spinner, SpinnerSize } from '@fluentui/react';
import { PlugConnectedRegular } from '@fluentui/react-icons';
import { useAdminAccess } from '../components/Auth/AuthProvider';
import AIConnectorHub from '../components/AIConnectorHub/AIConnectorHub';

const AIConnectorHubPage: React.FC = () => {
  const { isAdmin, isAdminLoading } = useAdminAccess();

  // Show loading while checking admin status
  if (isAdminLoading) {
    return (
      <Stack horizontalAlign="center" verticalAlign="center" style={{ height: '100vh' }}>
        <Spinner size={SpinnerSize.large} label="Checking permissions..." />
      </Stack>
    );
  }

  // Show access denied if not admin
  if (!isAdmin) {
    return (
      <Stack horizontalAlign="center" verticalAlign="center" style={{ height: '100vh', padding: '20px' }}>
        <Stack tokens={{ childrenGap: 20 }} horizontalAlign="center">
          <PlugConnectedRegular style={{ fontSize: '48px', color: '#d13438' }} />
          <Text variant="xxLarge" style={{ fontWeight: 600 }}>Access Denied</Text>
          <Text variant="large" style={{ textAlign: 'center', maxWidth: '400px' }}>
            You need administrative privileges to access the AI Connector Hub. Please contact your system administrator for access.
          </Text>
        </Stack>
      </Stack>
    );
  }

  return <AIConnectorHub />;
};

export default AIConnectorHubPage;
